export default __webpack_public_path__ + "static/alfonzo_g-751c352f922709f9b3a17f66646a2540.png";